import { hotelsApi } from '~/apis/hotelsApi'

import { HotelsSettingsPage } from '@mangovoice/hotels-ui'

import { HotelsAccessGate } from './HotelsAccessGate'
import { hotelsToast } from './hotelsToast'
import { useHotelsPageContext } from './useHotelsPageContext'

export const HotelsSettingsRoutePage = () => {
  const { t, locale, permissions, pbxId, pbxUuid } = useHotelsPageContext()

  if (!pbxId || !pbxUuid) {
    return null
  }

  return (
    <HotelsAccessGate requiredAccess="settings">
      <HotelsSettingsPage
        api={hotelsApi}
        pbxId={pbxId}
        pbxUuid={pbxUuid}
        toast={hotelsToast}
        permissions={permissions}
        showActivation={false}
        t={t}
        locale={locale}
      />
    </HotelsAccessGate>
  )
}
